<template>
    <div class="information">
        <information-confirm ref="cofirm"></information-confirm>
        <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <template v-for="item in tabPaneList">
                <el-tab-pane :label="item.label" :name="item.name" :key="item.name">
                    <component
                        :ref="item.name"
                        :is="item.componentId"
                        :user-info="UserInfo"
                        :form-screen-data="formScreenData"
                    >
                        <template slot="formScreen">
                            <form-screen
                                :ref="`${item.name}FormScreen`"
                                :form-type="item.name"
                                :form-data="formData"
                                @formChange="getSonCompanyList"
                                @confirm="formConfirm"
                                @resetSonCompany="resetSonCompany"
                            />
                            <el-divider></el-divider>
                        </template>
                    </component>
                </el-tab-pane>
            </template>
        </el-tabs> -->
    </div>
</template>

<script>
import formScreen from "./InformationDepartment/formScreen";
// import informationEnter from "./InformationDepartment/informationEnter";
import informationConfirm from "./InformationDepartment/informationConfirm";
// import informationOut from "./InformationDepartment/informationOut";

import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "information",
    components: {
        formScreen,
        // informationEnter,
        informationConfirm,
        // informationOut,
    },
    data() {
        return {
            // tabPaneList: [
            //     {
            //         name: "enter",
            //         label: "入库审核",
            //         componentId: "informationEnter",
            //     },
            //     {
            //         name: "cofirm",
            //         label: "订单确认",
            //         componentId: "informationConfirm",
            //     },
            //     {
            //         name: "out",
            //         label: "出库审核",
            //         componentId: "informationOut",
            //     },
            // ],
            formData: {
                listBranch: [],
                listSon: [],
                listChannel: [],
            },
            // activeName: "enter",
            tableDataTotal: 0,
            // 合并表格的id
            mergeTable: [],
            UserInfo: {},
            formScreenData: {},
        };
    },
    created() {
        // this.UserInfo = JSON.parse(localStorage.getItem("role"));
        // this.getList();
        // this.getBranchCompanyList();
    },
    methods: {
        handleClick(tab) {
            const { name } = tab;
            this.formScreenData = {};
            this.getChannelList();
            this.getList();
        },
        getList() {
            this.$nextTick(() => {
            //     const option = this.$refs[this.activeName][0];
            //     // console.log(option);
            //     option.getTableData(true);
                this.$refs.cofirm.getTableData(true);
            });
        },
        formConfirm(data) {
            this.formScreenData = data;
            // this.$refs.cofirmFormScreen.getTableData(true);
            this.$nextTick(() => {
            //     const option = this.$refs[this.activeName][0];
            //     option.getTableData(true);
                this.$refs.cofirm.getTableData(true);
            });
        },
        resetSonCompany() {
            this.formData.listSon = [];
        },
        getBranchCompanyList() {
            const API = Baseurl + "logisticsController/getAllBranchCompany";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.formData.listBranch = data;
                }
            });
        },
        getSonCompanyList(id) {
            const API = Baseurl + "logisticsController/getAllSubCompanyById";
            const paramsData = { id };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.formData.listSon = data;
                }
            });
        },
        getChannelList() {
            const API = Baseurl + "purchaseController/selectItemList";
            const paramsData = { itemCode: "HYXUN0000006" };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.formData.listChannel = data;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.information {
    width: 98%;
    overflow: hidden;
}
</style>
